import { styled as n } from "styled-components";
import t from "../Button/Button.mjs";
const d = /* @__PURE__ */ n.div.withConfig({
  componentId: "sc-f7f9fe47-0"
})([
  "",
  ""
], ({ theme: o }) => o.components.modal.outerWrapper), f = /* @__PURE__ */ n.div.withConfig({
  componentId: "sc-f7f9fe47-1"
})([
  "",
  ""
], ({ theme: o }) => o.components.modal.backdrop), i = /* @__PURE__ */ n(t).withConfig({
  componentId: "sc-f7f9fe47-2"
})([
  "",
  " svg{color:currentColor;}&:hover{svg{color:currentColor;}}"
], ({ theme: o }) => o.components.modal.closeButton), r = /* @__PURE__ */ n.span.withConfig({
  componentId: "sc-f7f9fe47-3"
})([
  "",
  ""
], ({ theme: o }) => o.components.modal.icon), s = /* @__PURE__ */ n.p.withConfig({
  componentId: "sc-f7f9fe47-4"
})([
  "",
  ""
], ({ theme: o }) => o.components.modal.heading), p = /* @__PURE__ */ n.div.withConfig({
  componentId: "sc-f7f9fe47-5"
})([
  "",
  ""
], ({ theme: o }) => o.components.modal.divider);
export {
  f as Backdrop,
  i as CloseButton,
  p as ModalDivider,
  s as ModalHeading,
  r as ModalIcon,
  d as OuterWrapper
};
